(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mj2027-offer-popup"]) return;
  try {
    
  (() => {
    const key = 'mj2027-offer-popup-v1';
    const initialize = (popup) => {
      if (popup.dataset.initialized || !popup.showModal) return;
      popup.dataset.initialized = 'true';
      const root = document.querySelector('.mj-dr');
      if (!root) return;
      let shown = false;
      let timer;
      let lastFocus;
      try { shown = sessionStorage.getItem(key) === 'seen'; } catch {}
      const stop = () => {
        clearTimeout(timer);
        window.removeEventListener('scroll', onScroll);
      };
      const open = () => {
        if (shown || !popup.isConnected || document.hidden) return;
        const vsl = document.querySelector('#mj-video video');
        if ((vsl && !vsl.paused && !vsl.ended) || document.activeElement?.tagName === 'IFRAME' || document.querySelector('dialog[open]')) {
          timer = setTimeout(open, 5000);
          return;
        }
        lastFocus = document.activeElement;
        popup.showModal();
        root.classList.add('mj-op-active');
        shown = true;
        try { sessionStorage.setItem(key, 'seen'); } catch {}
        stop();
      };
      const onScroll = () => {
        const travel = document.documentElement.scrollHeight - window.innerHeight;
        if (travel > 0 && window.scrollY / travel * 100 >= Number(popup.dataset.scrollPercent)) open();
      };
      const close = () => popup.close();
      popup.querySelector('[data-mj-popup-close]').addEventListener('click', close);
      popup.addEventListener('click', (event) => {
        if (event.target !== popup) return;
        const box = popup.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
      });
      popup.addEventListener('close', () => {
        root.classList.remove('mj-op-active');
        if (lastFocus?.isConnected && lastFocus !== document.body) lastFocus.focus({ preventScroll: true });
      });
      popup.querySelector('[data-mj-popup-offer]').addEventListener('click', close);
      if (!shown) {
        timer = setTimeout(open, Number(popup.dataset.delay) * 1000);
        window.addEventListener('scroll', onScroll, { passive: true });
      }
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(popup)) { close(); stop(); }
      });
    };
    document.querySelectorAll('[data-mj-offer-popup]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-mj-offer-popup]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
